// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig, } from "@hey-api/client-fetch";
export const client = createClient(createConfig({
    baseUrl: "https://api.dev-jtides.com/des-services/evo/v5.196.0",
}));
//# sourceMappingURL=client.gen.js.map